import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { Api } from '@/core/api';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';

export const QUERY_KEY_INCIDENT_TYPES = 'incident-types';

export const useIncidentTypesData = () => {
  const { orgId } = useCurrentUser();
  const { data, ...query } = useQuery({
    queryKey: [QUERY_KEY_INCIDENT_TYPES, orgId],
    queryFn: () => Api.mapEvents.getIncidentTypes({ orgId }),
    placeholderData: [],
    staleTime: Infinity,
  });

  return {
    data,
    incidentTypesData: isEmpty(data) ? [] : data!,
    ...query,
  };
};
